export default __webpack_public_path__ + "static/media/green-ship.094d7866.png";